import React from "react";
import ReactDOM from "react-dom";
import {
  Navigate,
  Outlet,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import TempoUnavailableDS from "./components/deliveryServices/TempoUnavailableDS";
import DoordashDS from "./components/deliveryServices/doordash/Doordash";
import GrubHubNotice from "./components/deliveryServices/grubhub/GrubHubNotice";
import GrubHubDS from "./components/deliveryServices/grubhub/Grubhub";
import UberEatsDS from "./components/deliveryServices/ubereats/UberEats";
import StoreProvision, {
  loader as storeProvisionLoader,
} from "./components/deliveryServices/ubereats/provision/StoreProvision";
import UberEatsProvisioning, {
  loader as ubereatsProvisioningLoader,
} from "./components/deliveryServices/ubereats/provision/UberEatsProvisioning";
import { CreateStoreProvider } from "./context/CreateStoreContext.js";
import { StoreProvider } from "./context/StoreProvider";
import "./index.css";
import Error from "./pages/Error";
import Create from "./ui/Create/Create.js";
import GeneralErrorPage from "./ui/ErrorPage.js";
import Landing from "./ui/Landing/Landing.js";
import LoginV2 from "./ui/Login/Login.js";
import StoreDashboard from "./ui/StoreAdmin/StoreDashboard.js";
import V2Payment, { loader as checkoutLoader } from "./ui/Stripe/PaymentV2.js";
import ThankYou, { loader as thankyouLoader } from "./ui/ThankYou/ThankYou.js";
import Onboarding, {
  loader as onboardingLoader,
} from "./ui/Integrator/Onboarding/Onboarding.js";
import ChangePassword from "./ui/ChangePassword/ChangePassword.js";
import Error404 from "./ui/ErrorPages/Error404/Error404.js";
import ForgotPasswordForm, {
  loader as forgotpasswordLoader,
} from "./ui/ChangePassword/ForgotPasswordForm.js";
import Requested from "./ui/ChangePassword/Requested.js";
import ResetPassword from "./ui/ChangePassword/ResetPassword.js";
import ResetPasswordForm from "./ui/ChangePassword/ResetPasswordForm.js";
import Success from "./ui/ChangePassword/Success.js";
import { loader as posLoader } from "./pages/pos/loader.js";
import DeliveryServices, {
  loader as dsloader,
} from "./pages/pos/DeliveryServices";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <CreateStoreProvider>
        <Outlet />
      </CreateStoreProvider>
    ),
    errorElement: <GeneralErrorPage />,
    children: [
      { index: true, element: <Landing /> },
      { path: "login", element: <LoginV2 /> },
      { path: "create", element: <Create /> },
      { path: "checkout", element: <V2Payment />, loader: checkoutLoader },
      { path: "thankyou", element: <ThankYou />, loader: thankyouLoader },
      { path: "dashboard", element: <StoreDashboard /> },
      {
        path: "pos_onboarding",
        element: <Onboarding />,
        loader: onboardingLoader,
      },
      {
        path: "forgotpassword",
        element: <ChangePassword />,
        children: [
          {
            index: true,
            element: <ForgotPasswordForm />,
            loader: forgotpasswordLoader,
          },
          { path: "requested", element: <Requested /> },
        ],
      },
      {
        path: "reset-password/:id/:token",
        element: <ResetPassword />,
        children: [
          { index: true, element: <ResetPasswordForm /> },
          { path: "success", element: <Success /> },
        ],
      },
    ],
  },
  {
    path: "/ubereats",
    element: <UberEatsProvisioning />,
    errorElement: <Error />,
    loader: ubereatsProvisioningLoader,
  },
  {
    path: "ubereats/:action",
    element: <StoreProvision />,
    errorElement: <Error />,
    loader: storeProvisionLoader,
  },
  {
    path: "/pos",
    element: <Outlet />,
    loader: posLoader,
    errorElement: <Error />,
    children: [
      { index: true, element: <Navigate to={"delivery-services"} replace /> },
      {
        path: "delivery-services",
        element: <DeliveryServices />,
        loader: dsloader,
        children: [
          {
            index: true,
            element: <Navigate to={"doordash"} replace />,
          },
          { path: "bevz", element: <TempoUnavailableDS /> },
          { path: "doordash", element: <DoordashDS /> },
          { path: "grubhub", element: <GrubHubDS /> },
          { path: "grubhub/notice", element: <GrubHubNotice /> },
          { path: "ubereats", element: <UberEatsDS /> },
        ],
      },
    ],
  },
  { path: "*", element: <Error404 /> },
]);

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <RouterProvider router={router} />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
